"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addError = exports.startView = exports.configure = void 0;
const environment_1 = require("./environment");
const filter_1 = require("./filter");
const browser_rum_1 = require("@datadog/browser-rum");
const originWhitelist_1 = require("./originWhitelist");
const configure = ({
  appId,
  appName,
  appVersion,
  clientPublicToken,
  environment,
  trackViewsManually = false
}) => {
  browser_rum_1.datadogRum.init({
    allowedTracingUrls: originWhitelist_1.originWhitelist,
    applicationId: appId,
    beforeSend: filter_1.filterRumBeforeSend,
    clientToken: clientPublicToken,
    defaultPrivacyLevel: "mask",
    env: environment,
    proxy: options => (0, environment_1.proxyFor)(Object.assign(Object.assign({
      environment
    }, options), {
      path: "rum"
    })),
    service: appName,
    sessionReplaySampleRate: 0,
    sessionSampleRate: 100,
    silentMultipleInit: true,
    site: environment_1.DATADOG_SITE,
    telemetrySampleRate: 20,
    traceSampleRate: 100,
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: false,
    trackViewsManually: trackViewsManually,
    version: appVersion
  });
};
exports.configure = configure;
const startView = ({
  name: viewName
}) => {
  const filteredViewName = (0, filter_1.filterViewName)(viewName);
  browser_rum_1.datadogRum.startView(filteredViewName);
};
exports.startView = startView;
const addError = (error, context) => {
  const filteredError = (0, filter_1.filterUnknown)(error);
  const filteredContext = (0, filter_1.filterContext)(context);
  browser_rum_1.datadogRum.addError(filteredError, filteredContext);
};
exports.addError = addError;
